import { memo } from 'react';
import IframeResizer from 'iframe-resizer-react';

import { ENGINE_OIL_MFE } from './microfrontendsConfig';

type EngineOilMfeProps = {
    assetId: string;
    routePath?: string;
};

export const EngineOilMfe = memo(({ assetId, routePath }: EngineOilMfeProps) => (
    <IframeResizer
        src={ENGINE_OIL_MFE.url(assetId, routePath)}
        checkOrigin={false}
        data-testid="engine-oil-mfe"
        style={{
            width: '1px',
            minWidth: '100%',
            border: '0',
        }}
    />
));
